import FunnelForm from "@/components/FunnelForm";

// Contact at step 2 — abandons after that still become partial leads.
const steps = [
  {
    title: "Tell us about your property",
    fields: [
      { name: "address", label: "Property address", type: "text",
        placeholder: "123 Main St, Brooklyn, NY", required: true },
      { name: "property_type", label: "Property type", type: "choice", required: true,
        options: ["Condo", "Co-op", "Single Family", "Townhouse", "Multi-Family", "Other"] },
    ],
  },
  {
    title: "Where should we send your valuation?",
    fields: [
      { name: "name", label: "Full name", type: "text", placeholder: "John Doe", required: true },
      { name: "email", label: "Email", type: "email", placeholder: "you@email.com", required: true },
      { name: "phone", label: "Phone (optional)", type: "tel", placeholder: "+1 (555) 123-4567" },
    ],
  },
  {
    title: "A few details",
    fields: [
      { name: "bedrooms", label: "Bedrooms", type: "choice", required: true,
        options: ["1", "2", "3", "4", "5+"] },
      { name: "condition", label: "Current condition", type: "choice", required: true,
        options: ["Move-in ready", "Light updates", "Needs work", "Major renovation"] },
    ],
  },
  {
    title: "Your timeline",
    fields: [
      { name: "timeline", label: "When do you want to sell?", type: "choice", required: true,
        options: ["ASAP", "1–3 months", "3–6 months", "Just curious"] },
      { name: "reason", label: "Reason for selling (optional)", type: "text",
        placeholder: "Relocating, upsizing, downsizing…" },
      { name: "message", label: "Anything else? (optional)", type: "textarea",
        placeholder: "Recent upgrades, special features, etc." },
    ],
  },
];

export default function SellerFunnel() {
  return (
    <FunnelForm
      leadType="seller"
      subtitle="Home Valuation"
      title="What's your home worth today?"
      accent="#D4AF37"
      steps={steps}
      bgImage="https://images.pexels.com/photos/31666687/pexels-photo-31666687.jpeg"
    />
  );
}
